module.exports = __webpack_public_path__ + "static/media/slcs_logo.bb2ba5ed.jpg";